export enum OrderType {
    None = 0,
    Pending = 1,
    Favorite = 2,
    Submitted = 3,
}
